/*
 * Copyright (C) 2018 BarD Software s.r.o
 */
import { User } from './auth/Auth';
import {ClearRedirect, Dashboard, DesktopSignin, DesktopSigninArgs, UserGet} from './Routes';
import {MSG_ACCOUNT_ALREADY_EXISTS} from './utils/ErrorMessages';
import {setDashboardFlashMessage} from './utils/Ui';

import $ from 'jquery';


export function onUserReady(user: User) {
    window.currentUserId = user.id();
    if (window.callbackPort !== undefined) {
        const signinParams: DesktopSigninArgs = {
            callback: window.callbackPort,
        };
        if (window.fallbackTokenUi) {
            signinParams.fallback = 'true';
        }
        DesktopSignin.redirect(signinParams);
    } else if (window.redirectUrl) {
        window.location.assign(window.redirectUrl);
    }
    ClearRedirect.invoke();
}


/**
 * Asks the backend whether it knows this user: a Firebase account is not an account with us.
 *
 * @returns true if the account exists, false if the backend replies 404. Any other failure rejects.
 */
export function backendAccountExists(user: User): JQueryPromise<boolean> {
    const deferred = $.Deferred<boolean>();
    user.idToken().then((idToken) => {
        UserGet.invoke({ id: user.id(), idToken })
            .done(() => deferred.resolve(true))
            .fail((jqXHR: JQuery.jqXHR) => {
                if (jqXHR.status === 404) {
                    deferred.resolve(false);
                } else {
                    deferred.reject(jqXHR);
                }
            });
    }).catch((e) => deferred.reject(e));
    return deferred.promise();
}

/**
 * @returns true if a dashboard redirect was started, false if no backend account exists (404).
 */
export function redirectIfBackendAccountExists(user: User): JQueryPromise<boolean> {
    return backendAccountExists(user).done((exists) => {
        if (exists) {
            setDashboardFlashMessage(MSG_ACCOUNT_ALREADY_EXISTS);
            Dashboard.redirect();
        }
    });
}
